<template>
  <sp-chip class="slot-inspector-status-tag" :class="classModifiers" :color="color" :label="label">
    <sp-icon slot="prepend" class="slot-inspector-status-tag__icon" :name="icon" size="xxx-small"></sp-icon>
  </sp-chip>
</template>

<script setup>
import { computed } from "vue";
import { t } from "#ce/apps/SpAdmin/SpSlotInspectorApp/i18n";
import { ACTIONS_BY_KEY } from "#ce/apps/SpAdmin/SpSlotInspectorApp/actions";

const props = defineProps({
  /**
   * The payload's name for the action: `create`, `keepActive`, `deactivate` or `reject`.
   */
  action: {
    type: String,
    required: true,
  },
  /**
   * How many slots the action applies to, shown before the action: `27 Rejected`. Without a count the label is the
   * action alone: `Rejected`.
   */
  count: {
    type: Number,
    default: null,
  },
});

const definition = computed(() => ACTIONS_BY_KEY[props.action]);
const color = computed(() => definition.value.color);
const icon = computed(() => definition.value.icon);

const label = computed(() => {
  const { copy } = definition.value;

  if (props.count === null) {
    return t(`action_${copy}`);
  }

  return t(`result_${copy}`, { count: props.count });
});

const classModifiers = computed(() => ({ [`--${color.value}`]: true }));
</script>

<style scoped lang="scss">
.slot-inspector-status-tag {
  --sp-comp-chip-font-size: var(--sp-sys-typescale-small-font-size);
  --sp-comp-chip-font-weight: var(--sp-sys-font-weight-normal);
  --sp-comp-chip-line-height: var(--sp-ref-scale-16);
  --sp-comp-chip-padding-block: var(--sp-ref-scale-2);
  --sp-comp-chip-padding-inline: var(--sp-ref-scale-8);
  --sp-comp-chip-gap: var(--sp-ref-scale-4);
  --sp-comp-chip-border-width: 0;
  --sp-comp-chip-border-radius: var(--sp-ref-border-radius-sm);

  &.--info &__icon {
    --sp-comp-icon-fill: var(--sp-sys-color-info);
  }

  &.--success &__icon {
    --sp-comp-icon-fill: var(--sp-sys-color-success);
  }

  &.--warning &__icon {
    --sp-comp-icon-fill: var(--sp-sys-color-warning);
  }

  &.--danger &__icon {
    --sp-comp-icon-fill: var(--sp-sys-color-danger);
  }
}
</style>
